import dayjs from 'dayjs';
import { useEffect, useState } from 'react';


import { useReactToPrint } from "react-to-print";
// https://www.npmjs.com/package/react-to-print
import { useRef } from "react";


import { Box, flex } from '@mui/system';


import { generateId, complitePadStart } from '../scripts/utils';

import { Button, Typography, } from '@mui/material';

import { CreatFieldComponent } from './Fields';

import { ModelHandlingUnit } from './../models/ModelHandlingUnit'


import Popup from './Popup';

import HuLabel from './HuLabel';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import translations from '../scripts/translations';
import { TransportMode } from '../scripts/configData';

import { computeLoadingMeters } from '../scripts/canStack';

const DetailHandlingUnit = ({ dataShipement, setDataShipement, language }) => {

    const btns = translations.button[language];
    const page = translations.pages.shipment[language];

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });


    const [updateId, setUpdateId] = useState(0);

    const [currentHuPrint, setCurrentHuPrint] = useState(null);
    const [currentHuPrintPageIdx, setCurrentHuPrintPageIdx] = useState(null);

    const incrementUpdateId = () => {
        setUpdateId(prevId => prevId + 1);
    };

    const [popupData, setPopupData] = useState({
        open: false,
        code: null,
        id: null,
        fn: null,
        types: {
            hasCancel: false,
            hasConfirm: false,
        }
    });

    const handelAddHU = async () => {

        const handlingIdx = dataShipement.handlingIdx + 1;

        const newHu = {
            _id: generateId(),
            huCode: `HU-${complitePadStart(handlingIdx, 4, '0')}`,
            huDate: dayjs().toISOString(),
            huWeight: 0,
            huLength: 0,
            huWidth: 0,
            huHeight: 0,
            huVolume: 0,
            huLinearMeters: 0,
            isStackable: true,
            isReturnable: false,
            huWeightToVolumeRatio: 0,
            huChargeableWeight: 0,
        };

        console.log('New Handling Unit:', newHu);

        const handlingUnits = dataShipement.handlingUnits;
        handlingUnits.push(newHu);

        setDataShipement({ ...dataShipement, handlingUnits, handlingIdx });

    }


    const calculateTotalsUnits = (handlingUnits) => {

        let totalHandlingUnits = 0;
        let soWeight = 0;
        let soChargeableWeight = 0;
        let soVolume = 0;
        // let soLinearMeters = 0;
        let soWeightToVolumeRatio = 0;

        const volumeWeightRatio = TransportMode.find(tm => tm.key === dataShipement.transportMode)['volumeWeightRatio'];

        for (let i in handlingUnits) {
            totalHandlingUnits += 1;
            soWeight += parseFloat(handlingUnits[i].huWeight) || 0;
            soVolume += parseFloat(handlingUnits[i].huVolume) || 0;

            soChargeableWeight = Math.max(soWeight, soVolume * volumeWeightRatio)
            // soChargeableWeight += parseFloat(handlingUnits[i].huChargeableWeight) || 0;

            // soLinearMeters += parseFloat(handlingUnits[i].huLinearMeters) || 0;
            soWeightToVolumeRatio = parseFloat(soWeight) / parseFloat(soVolume)
        }

        return {
            totalHandlingUnits: totalHandlingUnits.toFixed(0),
            soWeight: Math.ceil(soWeight),
            soChargeableWeight: Math.ceil(soChargeableWeight),
            soVolume: soVolume.toFixed(2),
            soLinearMeters: computeLoadingMeters([...handlingUnits]),
            soWeightToVolumeRatio: soWeightToVolumeRatio.toFixed(0)
        };
    }

    const handelUpdateHU = (e) => {

        let handlingUnits = dataShipement.handlingUnits

        handlingUnits = handlingUnits.map(hu => {
            if (hu._id === e._id) {
                return e
            }
            else {
                return hu;
            }
        });

        const data = calculateTotalsUnits(handlingUnits);

        setDataShipement({ ...dataShipement, handlingUnits, ...data });

        console.log('Handling Units before update:', e, updateId);


    }

    const handelCopyHU = (hu) => {
        const newHu = {
            ...hu,
            _id: generateId(),
            huCode: `HU-${complitePadStart(dataShipement.handlingIdx + 1, 4, '0')}`,
            huDate: dayjs().toISOString(),
            huWeight: 0,
            // huLength: 0,
            // huWidth: 0,
            // huHeight: 0,
            // huVolume: 0,
            // huLinearMeters: 0,
            // isStackable: true,
            // isReturnable: false,
            huWeightToVolumeRatio: 0,
            huChargeableWeight: 0,
        };
        console.log('New Handling Unit:', newHu);
        const handlingUnits = [...dataShipement.handlingUnits, newHu];
        const handlingIdx = dataShipement.handlingIdx + 1;
        const data = calculateTotalsUnits(handlingUnits);
        setDataShipement({ ...dataShipement, handlingUnits, handlingIdx, ...data });
    }


    const remove = (huId) => {

        const handlingUnits = dataShipement.handlingUnits.filter(hu => hu._id !== huId);

        const data = calculateTotalsUnits(handlingUnits);

        setDataShipement({ ...dataShipement, handlingUnits, ...data });

    }


    const handelDeleteHU = (huId) => {
        setPopupData({
            open: true,
            code: 'deleteHandlingUnitConfirmation',
            id: huId,
            fn: remove,
            types: {
                hasCancel: true,
                hasConfirm: true,
            }
        });
    }

    useEffect(() => {
        if (dataShipement.handlingUnits && dataShipement.handlingUnits.length > 0) {
            const data = calculateTotalsUnits(dataShipement.handlingUnits);
            setDataShipement({ ...dataShipement, ...data });
        }
    }
        , [updateId, dataShipement.transportMode]);


    const color = '#00000099'

    return (
        <Box>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 5}}>
                <Typography variant='overline' color={color} sx={{ fontSize: '.9rem' }} >{page.handlingUnits}</Typography>

                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={reactToPrintFn} variant="contained" color="primary" sx={{}}>{btns.print}</Button>
                    <Button onClick={handelAddHU} variant="contained" color="primary" sx={{}}>{btns.add}</Button>
                </Box>

            </Box>

            <div style={{ display: 'none' }}><HuLabel dataShipement={dataShipement} contentRef={contentRef} currentHuId={currentHuPrint} pageIdx={currentHuPrintPageIdx} /></div>

            {dataShipement.handlingUnits && dataShipement.handlingUnits.length > 0 ? (
                <Box sx={{ mb: 2 }}>

                    {dataShipement.handlingUnits.map((hu, index) => (
                        <Box
                            key={hu._id}
                            sx={{
                                border: '1px solid #ccc',
                                padding: 2,
                                marginBottom: 2,
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: 1,
                                alignItems: 'center',
                                borderRadius: 1,
                            }}>

                            <Box sx={{}}>

                                <Box sx={{
                                    display: 'grid', gridTemplateColumns: '6fr 1fr', gap: 6,
                                }}>
                                    <Box sx={{
                                        display: 'grid', gridTemplateColumns: '.3fr 1fr 1fr 1fr 1fr 1fr',
                                        flexDirection: 'row', gap: 2,
                                        alignItems: 'center',
                                    }}>
                                        <Typography variant="body1"> N° {index + 1}</Typography>
                                        <CreatFieldComponent field={ModelHandlingUnit.huWeight} data={hu} updateData={handelUpdateHU} mainData={dataShipement} fn={incrementUpdateId} />
                                        <CreatFieldComponent field={ModelHandlingUnit.huLength} data={hu} updateData={handelUpdateHU} mainData={dataShipement} fn={incrementUpdateId} />
                                        <CreatFieldComponent field={ModelHandlingUnit.huWidth} data={hu} updateData={handelUpdateHU} mainData={dataShipement} fn={incrementUpdateId} />
                                        <CreatFieldComponent field={ModelHandlingUnit.huHeight} data={hu} updateData={handelUpdateHU} mainData={dataShipement} fn={incrementUpdateId} />
                                        <CreatFieldComponent field={ModelHandlingUnit.huLinearMeters} data={hu} updateData={handelUpdateHU} mainData={dataShipement} fn={incrementUpdateId} />

                                    </Box>
                                    <Box sx={{
                                        display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: 'auto',
                                        flexDirection: 'row', gap: 0,
                                        alignItems: 'center',
                                    }}>
                                        <CreatFieldComponent field={ModelHandlingUnit.isStackable} data={hu} updateData={handelUpdateHU} mainData={dataShipement} />
                                        <CreatFieldComponent field={ModelHandlingUnit.isReturnable} data={hu} updateData={handelUpdateHU} mainData={dataShipement} />
                                    </Box>
                                </Box>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }} >

                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row', alignItems: 'center',
                                        gap: 4,
                                        ml: 7
                                    }}>

                                        <Typography variant="overline"> {ModelHandlingUnit.huCode[language]} : {hu.huCode}</Typography>
                                        <Typography variant='overline'> {ModelHandlingUnit.huVolume[language]} : {hu.huVolume}</Typography>
                                        <Typography variant="overline"> {ModelHandlingUnit.huWeightToVolumeRatio[language]} : {hu.huWeightToVolumeRatio}</Typography>
                                        <Typography variant="overline"> {ModelHandlingUnit.huChargeableWeight[language]} : {hu.huChargeableWeight}</Typography>

                                    </Box>
                                    <Box sx={{ mr: 1.5 }}>
                                        <LocalPrintshopIcon color='primary' sx={{ cursor: 'pointer' }} onClick={ async () =>  {
                                            await setCurrentHuPrint(hu._id);
                                            await setCurrentHuPrintPageIdx(`${index + 1}/${dataShipement.handlingUnits.length}`);
                                            await reactToPrintFn();
                                        }} />
                                    </Box>

                                </Box>

                            </Box>

                            <Box sx={{ borderLeft: '1px solid #ccc', height: '50px' }}></Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                <DeleteOutlineIcon color='secondary' sx={{ cursor: 'pointer' }} onClick={() => handelDeleteHU(hu._id)} />
                                <ContentCopyIcon fontSize='small' color='primary' sx={{ cursor: 'pointer', }} onClick={() => handelCopyHU(hu)} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            ) : ""}

            {popupData.open && <Popup popupData={popupData} setPopupData={setPopupData} />}


        </Box>
    );
}

export default DetailHandlingUnit;
